import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { PORTAL_DISPLAY_NAME, formatPortalTitle } from './portal-display-name.token';

/**
 * Applies route `title` values as `{page} | {portalName}`.
 * Falls back to the portal name alone when a route has no title.
 */
@Injectable()
export class PortalTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly portalName = inject(PORTAL_DISPLAY_NAME);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const pageTitle = this.buildTitle(snapshot);
    this.title.setTitle(formatPortalTitle(pageTitle ?? '', this.portalName));
  }
}
